import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function WarrantyPage() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Navbar />
      <main>
        {/* Hero Header */}
        <section className="pt-28 md:pt-36 pb-12 md:pb-16 bg-dark-bg">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl">
            <p className="text-xs md:text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4">
              Legal
            </p>
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium text-charcoal-50 leading-tight tracking-tight-xl mb-6">
              Warranty Information
            </h1>
            <p className="text-base md:text-lg text-charcoal-300 font-sans leading-relaxed max-w-2xl">
              Coverage details for all Propre Purification systems and components. Please review the applicable warranty for your product below.
            </p>
          </div>
        </section>

        <section className="pb-24 md:pb-32 bg-dark-bg">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl flex flex-col gap-16 md:gap-20">

            {/* Crystal Quest Warranty */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="inline-block px-3 py-1 text-xs font-sans font-semibold uppercase tracking-wider bg-gold/10 text-gold border border-gold/20 rounded-full whitespace-nowrap">
                  Whole House filters
                </span>
              </div>
              <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-6">
                CRYSTAL QUEST® — One Year Limited Warranty
              </h2>
              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                CRYSTAL QUEST® warrants your CRYSTAL QUEST® Water Filter Systems for one year from the date of purchase (except replacement filters) against all defects in materials and workmanship, when used in compliance with the Use and Care Manual. CRYSTAL QUEST® disclaims all implied warranties, including without limitation, warranties of merchantability and fitness for a particular purpose. For specific information and guidelines please see the Crystal Quest Policies page on our website.
              </p>
              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                An RMA number should be obtained from Crystal Quest before returning any merchandise. If the product proves to be defective within one year from the date of purchase after an RMA number has been issued, ship the unit to CRYSTAL QUEST® and the entire system will be repaired or replaced without charge or your money will be refunded. Please package your CRYSTAL QUEST® unit carefully to avoid damage in transit.
              </p>
              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                This warranty gives you specific legal rights, and you may have other legal rights which vary from state to state. CRYSTAL QUEST® assumes no responsibility for incidental or consequential damages; for damages arising out of the misuse of the product or the use of any unauthorized attachment. Some states do not allow the exclusion or limitation of implied warranties or incidental or consequential damages, so the above limitations or exclusion may not apply to you.
              </p>
              <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                Should service be required during or after the warranty period, or should you have any question regarding how to use your CRYSTAL QUEST® Water Filter System, please contact our Support Department at{" "}
                <a
                  href="mailto:help@crystalquest.com"
                  className="text-gold hover:text-gold-light transition-colors underline underline-offset-2"
                >
                  help@crystalquest.com
                </a>
                .
              </p>

              <div className="mt-6 bg-gold/5 border border-gold/20 rounded-lg p-4 md:p-5">
                <p className="text-sm font-sans font-semibold text-gold mb-1">
                  Important Notice — Whole House filters
                </p>
                <p className="text-sm text-charcoal-300 font-sans leading-relaxed">
                  For the safety of our customers, media cannot be reused. Returns on all media are not permitted.
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-dark-border" />

            {/* PRO-50 Warranty */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="inline-block px-3 py-1 text-xs font-sans font-semibold uppercase tracking-wider bg-charcoal-500 text-charcoal-100 border border-charcoal-400 rounded-full whitespace-nowrap">
                  Under-Sink RO
                </span>
              </div>
              <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-6">
                PRO-50 R.O. Drinking Water System — Five/One Year Limited Warranty
              </h2>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                Aqua Treatment Services Inc. warrants its PRO-50 R.O. Drinking Water System to be free from defects in materials and workmanship for a period of five years from the date of purchase when installed and operated within recommended parameters.
              </p>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                Aqua Treatment Services Inc. will repair or replace at its discretion any defective component. This warranty does not cover the disposable sediment and carbon filters whose service life depends on feed water conditions. The reverse osmosis membrane is warrantied for one year. If the required prefilter conditions to the membrane are not followed, the membrane will not be warrantied.
              </p>

              <h3 className="text-base font-sans font-semibold text-charcoal-50 mb-3 mt-8">
                Conditions of Warranty
              </h3>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                The above warranty shall not apply to any part of the PRO-50 R.O. Drinking Water System that is damaged because of occurrences including but not limited to neglect, misuse, alteration, accident, misapplication, physical damage, or damage caused by fire, acts of God, or freezing or hot water.
              </p>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                All replacement filters and membranes must be PRO-50 filters and membranes or the warranty is void. If the unit is altered by anyone other than Aqua Treatment Services Inc., the warranty is void. To obtain warranty service: (A) contact your local dealer who supplied the unit, or (B) contact the factory for the dealer nearest you. It is the obligation of the owner to pay for shipping or travel charges to return the defective part.
              </p>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                This is the sole warranty made by Aqua Treatment Services Inc. with respect to the PRO-50 R.O. Drinking Water System. No other warranties, expressed or implied, are given including merchantability or fitness for a particular purpose, incidental or consequential damages, or other losses.
              </p>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                This exclusion applies to the extent exclusion is permitted by the law.
              </p>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                No person or representative is authorized to assume for Aqua Treatment Services Inc. any liability on its behalf, or in its name, except to refer the purchaser to this warranty.
              </p>

              <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                This warranty gives you specific legal rights, you may also have other rights which vary from state to state.
              </p>

              <p className="text-xs text-charcoal-400 mt-6 font-sans">
                Form No. S3554-16-ATS &bull; 6.19.2025
              </p>

              <div className="mt-6 bg-charcoal-900/50 rounded-lg p-4 md:p-5 space-y-1">
                <p className="text-sm font-sans font-semibold text-charcoal-50 mb-2">
                  Aqua Treatment Service, Inc.
                </p>
                <p className="text-sm text-charcoal-300 font-sans">194 Hempt Road</p>
                <p className="text-sm text-charcoal-300 font-sans">Mechanicsburg, PA 17050</p>
                <div className="grid grid-cols-2 gap-4 mt-3">
                  <div>
                    <p className="text-sm font-sans font-semibold text-charcoal-50">Phone:</p>
                    <p className="text-sm text-charcoal-300 font-sans">(717) 697-4998</p>
                    <p className="text-sm text-charcoal-300 font-sans">(800) 224-7476</p>
                  </div>
                  <div>
                    <p className="text-sm font-sans font-semibold text-charcoal-50">Fax:</p>
                    <p className="text-sm text-charcoal-300 font-sans">(717) 697-5035</p>
                    <p className="text-sm text-charcoal-300 font-sans">(800) 787-0197</p>
                  </div>
                </div>
              </div>
            </div>

            {/* General Product Warranty */}
            <div className="border-t border-dark-border pt-12">
              <h2 className="font-serif text-xl md:text-2xl font-semibold text-charcoal-50 mb-6">
                General Product Warranty
              </h2>
              <p className="text-base text-charcoal-300 font-sans leading-relaxed mb-4">
                All products are warranted against defects in manufacturing and workmanship. We will repair, replace, or otherwise make operable any part or parts and return to the dealer without charge, providing the owner&apos;s obligations have been met. We are only responsible for repair or replacement of defective components during the warranty period (i.e., an assembly that has replacement or repairable parts will not be replaced in its entirety &mdash; only the defective parts under the condition of the manufacturer&apos;s warranty).
              </p>
              <p className="text-base text-charcoal-300 font-sans leading-relaxed">
                When items are returned under warranty, a return goods authorization is required. Shipments must be addressed to the WARRANTY DEPARTMENT and contain a full description of the problem. Upon completion of warranty work, the item will be returned with transportation charges prepaid. If after inspection we determine the item is not covered under our warranty, we will notify the customer for disposition before any action is taken.
              </p>
            </div>

          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}